<template>
    <div class="my-habits-motivation">

        <div>
            <!-- motivation graph button -->
            <b-btn class="graph-button"
                   @click="editHabitMotivation()">
                <my-habits-chart-motivation size="sm"
                                            :habit="habit">
                </my-habits-chart-motivation>

                <div class="graph-button__label">
                    {{ $i18n.gt('LABEL_MY_HABITS_MOTIVATION') }}
                </div>
            </b-btn>

            <!-- modal -->
            <b-modal hide-footer
                     :id="modalId"
                     :title="$i18n.gt('LABEL_MY_HABITS_MOTIVATION')">
                <b-alert show variant="info">
                    {{ habit.habit }}
                </b-alert>

                <div class="modal-section card p-2 light-bg">
                    <h5>{{ $i18n.gt('LABEL_MY_HABITS_IMPORTANCE') }}</h5>
                    <p>{{ $i18n.gt('LABEL_MY_HABITS_HOW_IMPORTANT') }}</p>

                    <my-habits-rating-slider :value="importanceSliderValue"
                                             :on-update="importanceSliderUpdated">
                    </my-habits-rating-slider>

                </div>
                <div class="modal-section card p-2 light-bg">
                    <h5>{{ $i18n.gt('LABEL_MY_HABITS_CONFIDENCE') }}</h5>
                    <p>{{ $i18n.gt('LABEL_MY_HABITS_HOW_CONFIDENT') }}</p>

                    <my-habits-rating-slider :value="confidenceSliderValue"
                                             :on-update="confidenceSliderUpdated">
                    </my-habits-rating-slider>
                </div>

                <div class="entry-buttons text-center">
                    <b-btn class="btn-cancel"
                           @click="cancelMotivationEntry()">
                        {{ $i18n.gt('LABEL_CANCEL') }}
                    </b-btn>
                    <b-btn variant="primary" class="ml-3"
                           @click="addMotivationEntry()">
                        {{ $i18n.gt('LABEL_MY_HABITS_ADD_ENTRY') }}
                    </b-btn>
                </div>

                <div class="modal-section border-top pt-3">
                    <h4>{{ $i18n.gt('LABEL_MY_HABITS_PREVIOUS_ENTRIES') }}</h4>

                    <div class="modal-section">
                        <my-habits-chart-motivation size="lg"
                                                    :habit="habit">
                        </my-habits-chart-motivation>
                        <b-alert show variant="secondary">
                            {{ $i18n.gt('LABEL_MY_HABITS_MOTIVATION_HELP') }}
                        </b-alert>
                    </div>
                </div>

            </b-modal>

        </div>
    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue'
import PatientPageMixin from "@/providers/PatientPageMixin";

/**
 * Button and modal to edit motivation data for a wellness Habit
 */
export default Vue.extend({
    name: 'MyHabitsMotivation',
    mixins: [PatientPageMixin],
    props: {
        habit: Object,
        index: Number
    },
    data() {
        return {
            importanceSliderValue: 5,
            confidenceSliderValue: 5,
        }
    },
    computed: {
        participant() {
            return this.$store.state.patientParticipant
        },
        modalId() {
            return `habitMotivationModal_${this.index}`
        }
    },
    methods: {
        editHabitMotivation() {
            this.$bvModal.show(this.modalId)
        },
        cancelMotivationEntry() {
            this.$bvModal.hide(this.modalId)
            this.importanceSliderValue = 5
            this.confidenceSliderValue = 5
        },
        addMotivationEntry() {
            // TODO: restrict frequency of entries?
            if (!this.habit.motivationEntries) {
                this.habit.motivationEntries = []
            }
            this.habit.motivationEntries.push({
                timestamp: new Date(),
                importance: this.importanceSliderValue,
                confidence: this.confidenceSliderValue
            })
            // console.log(this.habit)
            this.$bvModal.hide(this.modalId)
            this.importanceSliderValue = 5
            this.confidenceSliderValue = 5
            this.saveParticipant()
        },
        importanceSliderUpdated(uid, val) {
            this.importanceSliderValue = val
        },
        confidenceSliderUpdated(uid, val) {
            this.confidenceSliderValue = val
        },
    },
})
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">

.my-habits-motivation {
    display: inline-block;
}

</style>
